export default __webpack_public_path__ + "static/media/download.icon.44543c93.svg";